/**
 * Support thread sender labels — aligned with admin StaffManagement ROLE_TONE.
 */

export const ADMIN_ROLE_LABELS = {
  super_admin: 'Super Admin',
  ops_manager: 'Ops Manager',
  ops_executive: 'Ops Executive',
  viewer: 'Viewer',
  accounts: 'Accounts',
  admin: 'Staff',
  internal: 'Internal',
  system: 'System',
};

export const CUSTOMER_TYPE_LABELS = {
  agent: 'Agent',
  b2c: 'Customer',
};

export function adminRoleLabel(role) {
  if (!role) return 'Staff';
  return ADMIN_ROLE_LABELS[role] || role.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * @param {object} msg - support message row
 * @param {object} opts
 * @param {'admin'|'customer'} opts.view - admin desk vs agent/B2C ticket detail
 * @param {boolean} opts.isSelf - show "You" for the viewer's own messages
 */
export function formatSupportSenderLabel(msg, opts = {}) {
  const { view = 'admin', isSelf = false } = opts;
  if (isSelf) return 'You';

  const type = msg?.sender_type || '';
  const name = (msg?.sender_name || '').trim();
  const role = msg?.sender_role || '';

  if (type === 'admin') {
    if (view === 'customer') {
      return name ? `Support — ${name}` : 'Support';
    }
    const roleLabel = adminRoleLabel(role);
    return name ? `${roleLabel} — ${name}` : roleLabel;
  }

  if (type === 'internal') {
    const roleLabel = adminRoleLabel(role || 'internal');
    return name && name !== 'Admin' ? `${roleLabel} — ${name}` : roleLabel;
  }

  if (type === 'agent') {
    return name ? `${CUSTOMER_TYPE_LABELS.agent} — ${name}` : CUSTOMER_TYPE_LABELS.agent;
  }

  if (type === 'b2c') {
    return name ? `${CUSTOMER_TYPE_LABELS.b2c} — ${name}` : CUSTOMER_TYPE_LABELS.b2c;
  }

  if (type === 'system') {
    if (role === 'accounts') return name ? `${ADMIN_ROLE_LABELS.accounts} — ${name}` : ADMIN_ROLE_LABELS.accounts;
    return name || 'System';
  }

  return name || type || 'Unknown';
}

/** True when the message was sent by the ticket owner (agent or B2C). */
export function isOwnTicketMessage(msg, ticket) {
  if (!msg || !ticket) return false;
  if (msg.sender_id && ticket.created_by && msg.sender_id === ticket.created_by) return true;
  const st = msg.sender_type;
  const ct = ticket.created_by_type;
  return (st === 'agent' || st === 'b2c') && st === ct;
}
